"use client";

import { Link as NextIntlLink, usePathname } from "@lib/i18n/navigation-pages-router";
import classNames from "classnames";
import nProgress from "nprogress";

export default function Link({
  children,
  href = "",
  className = "",
  noUnderline = false,
  disabled = false,
  onClick = () => {},
  ...other
}) {
  const pathname = usePathname();

  function handleClick(e) {
    if (disabled) {
      e.preventDefault();
      return;
    }

    nProgress.start();

    if (pathname === href) {
      nProgress.done();
    }

    onClick(e);
  }

  return (
    <NextIntlLink
      href={href}
      className={classNames(className, noUnderline && "no-underline", disabled && "disabled")}
      onClick={handleClick}
      {...other}
    >
      {children}
    </NextIntlLink>
  );
}
